export const PRESENCE_LISTEN_REQUEST = "PRESENCE_LISTEN_REQUEST";
export const PRESENCE_LISTEN_SUCCESS = "PRESENCE_LISTEN_SUCCESS";
export const PRESENCE_LISTEN_FAILURE = "PRESENCE_LISTEN_FAILURE";

export const PRESENCE_SET_REQUEST = "PRESENCE_SET_REQUEST";
export const PRESENCE_SET_SUCCESS = "PRESENCE_SET_SUCCESS";
export const PRESENCE_SET_FAILURE = "PRESENCE_SET_FAILURE";
